import { defineStore } from 'pinia';
import { configRequest } from 'config-request';
import { getRequestIns } from '../requestIns';
export const useCombinationDetailStore = defineStore('combination-detail', {
    actions: {
        /**
         * 查询组合包单项弹窗详情
         * @param params
         */
        async getCombinationDetail(params, otherParams) {
            try {
                const result = await configRequest(getRequestIns()).getOptionalPackageDetail(params, otherParams);
                return result?.data ?? null;
            }
            catch (error) {
                return null;
            }
        },
    },
});
